import useVuelidate from '@vuelidate/core';

export default {
  data() {
    return {
      v$: useVuelidate(),
    };
  },
  computed: {
    $v() {
      return this.v$;
    },
  },
};
